import {
  SectionElement,
  defineElement,
  on,
  onClick,
  query,
  queryAll,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-contact-form-new/shop-contact-form-new.ts
var ShopContactFormNew = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.steps = ["first-step", "second-step", "third-step", "fourth-step", "success"];
    this.step = 1;
    this.recaptchaLoaded = false;
  }
  connectedCallback() {
    this.updateStepTabIndices();
  }
  onConsentCheckboxChange() {
    if (this.consentCheckbox.checked && !this.recaptchaLoaded) {
      this.loadRecaptchaScript();
    }
  }
  loadRecaptchaScript() {
    return __async(this, null, function* () {
      if (this.recaptchaLoaded)
        return;
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=6LeEl08qAAAAABhP6ACT65yJS2CZ-WJLm1YB55fM";
        script.async = true;
        script.defer = true;
        script.onload = () => {
          this.recaptchaLoaded = true;
          resolve();
        };
        script.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
        document.head.appendChild(script);
      });
    });
  }
  handleKeydown(element, event) {
    if (event.key === "Enter") {
      if (element.tagName === "INPUT") {
        event.preventDefault();
        element.click();
      }
    }
  }
  updateStepTabIndices() {
    const currentStepClass = this.steps[this.step - 1];
    this.allSteps.forEach((step) => {
      const stepDataAttr = step.getAttribute("data-first-step") !== null ? "first-step" : step.getAttribute("data-second-step") !== null ? "second-step" : step.getAttribute("data-third-step") !== null ? "third-step" : step.getAttribute("data-fourth-step") !== null ? "fourth-step" : step.getAttribute("data-success") !== null ? "success" : "";
      const isActiveStep = stepDataAttr === currentStepClass;
      const focusableElements = step.querySelectorAll('input, button, textarea, select, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach((element) => {
        if (isActiveStep) {
          element.removeAttribute("tabindex");
        } else {
          element.setAttribute("tabindex", "-1");
        }
      });
    });
  }
  onContinueClick(elm) {
    return __async(this, null, function* () {
      let valid = true;
      if (this.step === 2) {
        this.inputsSecond.forEach((input) => {
          if (!input.validity.valid) {
            valid = false;
            this.classList.add("error");
          }
        });
      } else if (this.step === 3) {
        this.inputsThird.forEach((input) => {
          if (!input.validity.valid) {
            valid = false;
            this.classList.add("error");
          }
        });
      } else if (this.step === 4) {
        this.inputsFourth.forEach((input) => {
          if (!input.validity.valid) {
            valid = false;
            this.classList.add("error");
          }
        });
        if (valid) {
          yield this.submitForm(elm);
          return;
        }
      }
      if (!valid)
        return;
      yield this.changeStep(1, elm);
    });
  }
  changeStep(delta, loadingIndicator) {
    return __async(this, null, function* () {
      const prevStep = this.step;
      const nextStep = Math.max(prevStep + delta, 1);
      this.step = nextStep;
      const prevClass = this.steps[prevStep - 1];
      const nextClass = this.steps[nextStep - 1];
      loadingIndicator == null ? void 0 : loadingIndicator.setAttribute("loading", "");
      loadingIndicator == null ? void 0 : loadingIndicator.removeAttribute("loading");
      this.classList.remove("error");
      this.classList.remove(prevClass);
      this.classList.add(nextClass);
      this.updateStepTabIndices();
      yield wait(300);
    });
  }
  onBackClick() {
    return __async(this, null, function* () {
      yield this.changeStep(-1);
    });
  }
  onResetClick() {
    return __async(this, null, function* () {
      this.step = 1;
      this.classList.remove("success", "error");
      this.classList.add("first-step");
      this.updateStepTabIndices();
      this.querySelectorAll("input, textarea").forEach((element) => {
        if (element instanceof HTMLInputElement) {
          if (element.type === "checkbox") {
            element.checked = false;
          } else {
            element.value = "";
          }
        } else if (element instanceof HTMLTextAreaElement) {
          element.value = "";
        }
      });
    });
  }
  submitForm(loadingIndicator) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f;
      try {
        if (!this.consentCheckbox.checked) {
          throw new Error("User has not given consent for reCAPTCHA.");
        }
        loadingIndicator.setAttribute("loading", "");
        if (!this.recaptchaLoaded) {
          yield this.loadRecaptchaScript();
        }
        const captchaToken = yield this.executeRecaptcha();
        const typeCheckboxes = this.querySelectorAll('input[name="contact[reason]"]:checked');
        const type = Array.from(typeCheckboxes).map((cb) => cb.value);
        const formData = {
          lang: this.dataset.lang || "en",
          captchaToken,
          type,
          name: ((_a = this.querySelector('input[name="contact[first_name]"]')) == null ? void 0 : _a.value) || "",
          lastName: ((_b = this.querySelector('input[name="contact[last_name]"]')) == null ? void 0 : _b.value) || "",
          company: ((_c = this.querySelector('input[name="contact[company]"]')) == null ? void 0 : _c.value) || "",
          email: ((_d = this.querySelector('input[name="contact[email]"]')) == null ? void 0 : _d.value) || "",
          phone: ((_e = this.querySelector('input[name="contact[phone]"]')) == null ? void 0 : _e.value) || "",
          listOfArticles: ((_f = this.querySelector('textarea[name="contact[products]"]')) == null ? void 0 : _f.value) || ""
        };
        const response = yield fetch("/apps/bb-tools/submitConformity", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
        const result = yield response.json();
        if (!result.success) {
          this.classList.add("error");
          console.error("shop-contact-form-new error:", result.error);
          return;
        }
        yield this.changeStep(1, loadingIndicator);
      } catch (error) {
        this.classList.add("error");
        console.error("shop-contact-form-new error:", error);
      } finally {
        loadingIndicator.removeAttribute("loading");
      }
    });
  }
  executeRecaptcha() {
    return __async(this, null, function* () {
      if (!window.grecaptcha) {
        throw new Error("reCAPTCHA not loaded.");
      }
      return yield new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute("6LeEl08qAAAAABhP6ACT65yJS2CZ-WJLm1YB55fM", { action: "submit" }).then(resolve).catch(reject);
        });
      });
    });
  }
};
__decorateClass([
  queryAll("[data-input-second]")
], ShopContactFormNew.prototype, "inputsSecond", 2);
__decorateClass([
  queryAll("[data-input-third]")
], ShopContactFormNew.prototype, "inputsThird", 2);
__decorateClass([
  queryAll("[data-input-fourth]")
], ShopContactFormNew.prototype, "inputsFourth", 2);
__decorateClass([
  queryAll("[data-first-step], [data-second-step], [data-third-step], [data-fourth-step], [data-success]")
], ShopContactFormNew.prototype, "allSteps", 2);
__decorateClass([
  query("[data-consent-checkbox]")
], ShopContactFormNew.prototype, "consentCheckbox", 2);
__decorateClass([
  on("change", "[data-consent-checkbox]")
], ShopContactFormNew.prototype, "onConsentCheckboxChange", 1);
__decorateClass([
  on("keydown", "input, textarea")
], ShopContactFormNew.prototype, "handleKeydown", 1);
__decorateClass([
  onClick("[data-continue]")
], ShopContactFormNew.prototype, "onContinueClick", 1);
__decorateClass([
  onClick("[data-back]")
], ShopContactFormNew.prototype, "onBackClick", 1);
__decorateClass([
  onClick("[data-reset]")
], ShopContactFormNew.prototype, "onResetClick", 1);
ShopContactFormNew = __decorateClass([
  defineElement("shop-contact-form-new")
], ShopContactFormNew);
export {
  ShopContactFormNew
};
